import { render, staticRenderFns } from "./TreeView.vue?vue&type=template&id=20dde8ab&scoped=true&"
import script from "./TreeView.vue?vue&type=script&lang=js&"
export * from "./TreeView.vue?vue&type=script&lang=js&"
import style0 from "./TreeView.vue?vue&type=style&index=0&id=20dde8ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20dde8ab",
  null
  
)

export default component.exports